import React from 'react';
import { View } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import { get as _get } from 'lodash';
import PropTypes from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import ConsumerAddOnsCard from '@vfgroup-oneplatform/framework/AddOns/Components/AddOnsCard';

import styles from './AddOnsCard.Styles';

function renderCardFooter(item, withUsers) {
  const userCount = _get(item, 'users.length', 0);
  const userCountKey =
    userCount > 1 ? 'soho_addons_users_count_format' : 'soho_addons_user_count_format';

  return (
    <>
      {withUsers && (
        <VFText i18nKey={userCountKey} placeHolders={[userCount]} style={styles.usersTextStyle} />
      )}
    </>
  );
}

function renderCardBody(item, isCurrencyFirst) {
  const price = isCurrencyFirst
    ? `${item?.price?.currency}${item?.price?.value}`
    : `${item?.price?.value}${item?.price?.currency}`;
  const { unitOfMeasure = '' } = item?.price;

  return <VFText i18nKey={`${price}${unitOfMeasure}`} style={styles.priceTextStyle} />;
}

function AddonsCard({ isRecommended, withUsers, style, isCurrencyFirst, ...props }) {
  if (isRecommended) {
    return (
      <>
        <View style={styles.recommendedContainerStyle}>
          <VFText i18nKey="soho_addons_recommended_for_you" style={styles.recommendedTextStyle} />
        </View>
        <ConsumerAddOnsCard
          style={[styles.recommendedCardStyle, style]}
          renderAddOnsCardFooter={item => renderCardFooter(item, false)}
          renderCardBody={item => renderCardBody(item, isCurrencyFirst)}
          topTextStyle={styles.nameTextStyle}
          {...props}
        />
      </>
    );
  }

  return (
    <ConsumerAddOnsCard
      style={[styles.cardStyle, style]}
      renderAddOnsCardFooter={item => renderCardFooter(item, withUsers)}
      renderCardBody={item => renderCardBody(item, isCurrencyFirst)}
      topTextStyle={styles.nameTextStyle}
      {...props}
    />
  );
}

AddonsCard.defaultProps = {
  isRecommended: false,
  withUsers: false,
  isCurrencyFirst: false,
};

AddonsCard.propTypes = {
  isRecommended: PropTypes.bool,
  withUsers: PropTypes.bool,
  style: ViewPropTypes.style,
  isCurrencyFirst: PropTypes.bool,
};

export { renderCardFooter, renderCardBody };
export default AddonsCard;
